import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(() => ({
  formFieldsContainer: {
    display: 'grid',
    gridGap: '20px',
  },
}));

export const FormFieldsContainer: React.FC = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.formFieldsContainer}>{children}</div>;
};
